module.exports = __webpack_public_path__ + "static/media/logo.015a0100.png";